/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import * as Flags from 'country-flag-icons/react/3x2'

export default function CountryTick({
  countryCode,
  countryName,
  id,
  position: { y },
  isNotFlags = false,
  onClick,
  activeCountryName,
}: {
  countryCode: keyof typeof Flags
  id: number
  countryName: string
  position: { y: number }
  isNotFlags?: boolean
  onClick?: any
  activeCountryName?: string
}) {
  const Flag = Flags[countryCode]
  const active = activeCountryName === countryName
  return (
    <svg className={isNotFlags ? 'text-bar-chart-report' : 'text-bar-chart-axis'}>
      <text style={{ fontFamily: 'CircularStdBook', fill: active ? '#872996' : '#041b33' }} y={y + 5}>
        {id}
      </text>
      {!isNotFlags && (Flag ? <Flag width={30} height={20} y={y - 10} x={25} title={countryName} /> : <svg />)}
      <text
        y={y + 5}
        x={!isNotFlags ? 60 : 16}
        style={{ fontFamily: 'CircularStdBook', fill: active ? '#872996' : '#041b33' }}
        className={onClick ? 'country-name' : ''}
        onClick={onClick}
      >
        {countryName}
      </text>
    </svg>
  )
}
